// package imports
import { Session } from 'next-auth';
import { signOut } from 'next-auth/react';

// local imports
import { clearSessionStore, setSigningOutState } from 'services/storageUtils';
import { clientSideLogout } from 'services/authClientUtils';
import { NavigationItem } from './SiteHeaderTypes';
import { isCustomer } from '../../../services/subscriptionUtils';
import { isBoysTownAdmin } from '../../../services/roleUtils';
import { canAccessObservations } from 'components/agility-pageModules/observation/utils/ObservationUtils';

export const doSignOut = async (session: Session) => {
  clearSessionStore();
  setSigningOutState();
  if (session && session.logout_url) {
    const parsedUrl = new URL(session.logout_url);
    const allowedHosts = ['b2clogin.com'];
    if (allowedHosts.find((h) => parsedUrl.host.indexOf(h) > -1)) {
      // force clearing the b2c signin session.
      await signOut({ redirect: false });
      //window.setTimeout(async () => {
      await clientSideLogout(session);
      //}, 100);
    } else {
      signOut({ callbackUrl: '/' });
    }
  } else {
    signOut({ callbackUrl: '/' });
  }
};

export function filterNavigationLinks(
  links: NavigationItem[],
  session: Session | null,
  isMobile: boolean = false,
): NavigationItem[] {
  return links
    .map((link) => {
      if (link.fields?.mobileDisplayOnly === 'true' && !isMobile) {
        return null;
      }
      if (link.fields.subscriptionRequiredForDisplay === 'true') {
        if (isCustomer(session?.user)) {
          return link;
        }
        return null;
      }
      if (link.fields.notLoggedInUserOnlyDisplay === 'true') {
        if (session?.user) {
          return null;
        }
        return link;
      }
      if (link.fields.freeAccountUserOnlyDisplay === 'true') {
        if (session?.user && !isCustomer(session?.user)) {
          return link;
        }
        return null;
      }
      if (link.fields.adminOnlyDisplay === 'true') {
        if (isBoysTownAdmin(session)) {
          return link;
        }
        return null;
      }
      if (link.fields.observationPermissionRequired === 'true') {
        if (
          canAccessObservations(
            session,
            session?.user ? 'authenticated' : 'unauthenticated',
          ) &&
          !isBoysTownAdmin(session)
        ) {
          return link;
        }
        return null;
      }
      return link;
    })
    .filter((link): link is NavigationItem => link !== null);
}
